module.exports = __webpack_public_path__ + "static/logo-curacao-new-d03a9c620bdc9ea167269d128722b562.png";